import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AgentNavbar from "../../../component/AgentNavbar";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import BookWithUs from "../../../component/BookWithUs";
import TopPlaces from "../../../component/TopPlaces";
import { 
  CheckCircle,
} from "react-feather"; 
import { useNavigate } from "react-router-dom";

import Select from "react-select";
import { baseurl } from "../../../component/Baseurl";
import Navbar from "../../../component/Navbar";



function VisitorFlightSearch() {
  const [isOneWay, setIsOneWay] = useState(true); // To toggle between One Way and Roundtrip
  const [adults, setAdults] = useState(1); // Adult passengers count
  const [children, setChildren] = useState(0); // Children passengers count
  const [infants, setInfants] = useState(0); // Infant passengers count
  const [departureDate, setDepartureDate] = useState(""); // Departure date
  const [returnDate, setReturnDate] = useState(""); // Return date

  // Handle tab change
  const handleTabChange = (tab) => {
    if (tab === "oneway") {
      setIsOneWay(true);
    } else {
      setIsOneWay(false);
    }
  };
  const [terminals, setTerminals] = useState([]);
  const [fromTerminal, setFromTerminal] = useState(null); // For storing selected 'From' terminal
  const [toTerminal, setToTerminal] = useState(null);

  useEffect(() => {
    fetch(`${baseurl}getAllTerminals`)
      .then((response) => response.json())
      .then((data) => {
        setTerminals(data.data); // Assuming 'data' is an array of terminals
      })
      .catch((error) => {
        console.error("Error fetching terminals:", error);
      });
  }, []);

  // const filteredTerminals = terminals.filter(
  //   (terminal) => terminal.terminal_code !== fromTerminal?.value
  // );


  const filteredTerminals = Array.isArray(terminals)
  ? terminals.filter((terminal) => terminal.terminal_code !== fromTerminal?.value)
  : [];


  
  // Handle count changes for passengers
  const handleCountChange = (type, operation) => {
    if (type === "adults") {
      if (operation === "increase") setAdults(adults + 1);
      else if (operation === "decrease" && adults > 1) setAdults(adults - 1);
    } else if (type === "children") {
      if (operation === "increase") setChildren(children + 1);
      else if (operation === "decrease" && children > 0)
        setChildren(children - 1);
    } else if (type === "infants") {
      if (operation === "increase") setInfants(infants + 1);
      else if (operation === "decrease" && infants > 0) setInfants(infants - 1);
    }
  };

  // Handle form submission

const navigate = useNavigate();

const handleSubmit = (e) => {
  e.preventDefault();

  const requestData = {
    AdultCount: adults.toString(),
    ChildCount: children.toString(),
    InfantCount: infants.toString(),
    JourneyType: isOneWay ? "OneWay" : "RoundTrip",
    PreferredAirlines: e.target.airline.value || "All",
    CabinClass: e.target.cabinClass.value || "All",
    Origin: e.target.from.value.toUpperCase(),
    Destination: e.target.to.value.toUpperCase(),
    DepartureDate: departureDate + "T00:00:00",
    ...(isOneWay ? {} : { ReturnDate: returnDate + "T00:00:00" }),
    FromTerminal: fromTerminal?.value || "",
    ToTerminal: toTerminal?.value || "",
  };

  console.log("Navigating with data:", requestData);

  // Convert object to URL query parameters
  const queryString = new URLSearchParams(requestData).toString();

  navigate(`/flight-search-result?${queryString}`); // Navigate with query params
};
  

  

  useEffect(() => {
    // Initialize jQuery datepicker after component mounts
    $("#departure-datepicker").datepicker({
      dateFormat: "dd M y", // Date format for display
      onSelect: function (dateText, inst) {
        setDepartureDate(
          inst.selectedYear +
            "-" +
            (inst.selectedMonth + 1) +
            "-" +
            inst.selectedDay
        ); // Standard date format (YYYY-MM-DD)
        // Set min date for return date as the selected departure date
        $("#return-datepicker").datepicker(
          "option",
          "minDate",
          new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay)
        );
      },
    });

    if (!isOneWay) {
      $("#return-datepicker").datepicker({
        dateFormat: "dd M y", // Date format for display
        onSelect: function (dateText, inst) {
          setReturnDate(
            inst.selectedYear +
              "-" +
              (inst.selectedMonth + 1) +
              "-" +
              inst.selectedDay
          ); // Standard date format (YYYY-MM-DD)
        },
      });
    }
  }, [isOneWay]);


 


  return (
    <>
   <Navbar/>


      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <h1 className="text-start  agenth1  font3 txt6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40px"
              viewBox="0 -960 960 960"
              width="40px"
              fill="#000000"
            >
              <path d="M394.33-117.67 298-298.33l-181.33-97 63-62.67 147 26.33L442-546.33 118.33-684l76-76.67L586.67-692l130-130q21.66-21.67 52.66-21.67 31 0 52.67 21.67t21.67 52.5q0 30.83-21.67 52.5L691.67-586.67l68.66 392L684-118.33 546-442 431.33-326.67l26 146-63 63Z" />
            </svg>
            Search Flights
          </h1>
          <hr />

          <div className="d-flex align-items-center mb-3">
            <div
              className={`me-2 ${isOneWay ? "tabactive" : "deflt"}`}
              onClick={() => handleTabChange("oneway")}
            >
              {isOneWay ? <CheckCircle size={15} /> : ""} One Way
            </div>
            <div
              className={`me-2 ${!isOneWay ? "tabactive" : "deflt"}`}
              onClick={() => handleTabChange("roundtrip")}
            >
              {!isOneWay ? <CheckCircle size={15} /> : ""} Roundtrip / Return
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="row g-3 text-start mb-3">
              <div className="col-md-4 mx-0 px-0">
  <label className="text-dark mb-2 labelset1 font3">From</label>
  <Select
    options={(terminals || []).map((terminal) => ({
      value: terminal.terminal_code,
      label: terminal.terminal_name,
    }))}
    name="from"
    className="input2"
    placeholder="Select Departure"
    value={fromTerminal}
    onChange={setFromTerminal}
  />
</div>

<div className="col-md-4 mx-0 px-0">
  <label className="text-dark mb-2 labelset1 font3">To</label>
  <Select
    options={(filteredTerminals || []).map((terminal) => ({
      value: terminal.terminal_code,
      label: terminal.terminal_name,
    }))}
    name="to"
    className="input2"
    placeholder="Select Arrival"
    value={toTerminal}
    onChange={setToTerminal}
  />
</div>

                <div className="col-md-2 mx-0 px-0">
                  <label className="text-dark mb-2 labelset1 font3">
                    Departure
                  </label>
                  <input
                    type="text"
                    id="departure-datepicker"
                    className="input2"
                    name="departure"
                    placeholder="Select date"
                  />
                </div>

                {!isOneWay && (
                  <div className="col-md-2 mx-0 px-0">
                    <label className="text-dark mb-2 labelset1 font3">
                      Return
                    </label>
                    <input
                      type="text"
                      id="return-datepicker"
                      className="input2"
                      name="return"
                      placeholder="Select date"
                    />
                  </div>
                )}
              </div>

              <div className="row g-2 text-start mb-4">
                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">
                    Cabin Class
                  </label>
                  <select className="input1" name="cabinClass">
                    <option>Economy</option>
                    <option>Business</option>
                    <option>PremiumEconomy</option>
                    <option>First</option> 
                    

                  </select>
                </div>

                <div className="col-md-3">
                  <label className="text-dark mb-2 labelset1 font3">
                    Preferred Airline
                  </label>
                  <select className="input1" name="airline">
                    <option>All</option>
                    <option>Air India</option>
                    <option>Indigo</option>
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">
                    Adults(12+)
                  </label>
                  <div className="d-flex justify-content-between align-items-center bg-white p-1 rounded border">
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("adults", "decrease")}
                    >
                      -
                    </span>
                    <span>{adults}</span>
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("adults", "increase")}
                    >
                      +
                    </span>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="text-dark  mb-2 labelset1 font3">
                    Children(2-11)
                  </label>
                  <div className="d-flex justify-content-between align-items-center bg-white p-1 rounded border">
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("children", "decrease")}
                    >
                      -
                    </span>
                    <span>{children}</span>
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("children", "increase")}
                    >
                      +
                    </span>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="text-dark mb-2 labelset1 font3">
                    Infants(0-2)
                  </label>
                  <div className="d-flex justify-content-between align-items-center bg-white p-1 rounded border">
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("infants", "decrease")}
                    >
                      -
                    </span>
                    <span>{infants}</span>
                    <span
                      className="btn3"
                      onClick={() => handleCountChange("infants", "increase")}
                    >
                      +
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <button type="submit" className="submit-btn">
                  Search
                </button>
              </div>
            </form>
            <hr className="mt-4" />

            <p>
              The Search Flight page allows users to effortlessly find and book
              flights. Simply enter the departure and destination locations,
              choose your travel dates, and select the number of passengers. The
              streamlined interface ensures a hassle-free flight booking
              experience.
            </p>
          </div>
        </div>
      </div>

      <TopPlaces />
      <BookWithUs />
      <Footer />
    </>
  );
}

export default VisitorFlightSearch;
